import { useState } from "react";
import ItemSelectInput from "../../components/Input/ItemSelectInput";
import { SelectChangeEvent, Stack } from "@mui/material";
import { Field } from "../../utils/formSchema";
import { getItemList } from "../../utils/common";
import {
  dmsDomainsNames,
  dmsDomainsNamesTy,
} from "../../config/constants/domain";
import { RegionSelectInput } from "./RegionSelectInput";
import { DistrictSelectInput } from "./DistrictSelectInput";
import { ProgrammeSelectInput } from "./ProgrammeSelectInput";
import { DivisionSelectInput } from "./DivisionSelectInput";
import { FacilitySelectInput } from "./FacilitySelectInput";

interface InputProps {
  placeholder?: string;
  label: string;
  handleChange: (
    item: Field,
    domain: dmsDomainsNamesTy,
    label?: string
  ) => void;
  error?: boolean;
  direction?: "column" | "row";
  value?: {
    domain_name?: string;
    domain_id?: string;
  };
  submitAttempt?: boolean;
}

const DOMAIN_LIST_ITEMS = getItemList(dmsDomainsNames);
export const DomainSelectInput = ({
  placeholder,
  handleChange,
  label,
  error,
  direction = "column",
  value,
  submitAttempt = false,
}: InputProps) => {
  const [domain, setDomain] = useState<string | undefined>(
    value?.domain_name ?? undefined
  );

  const handleOnChange = (field: Field, label?: string) => {
    handleChange(field, (domain as dmsDomainsNamesTy) ?? "division", label);
  };
  const handleDomainUpdate = (event: SelectChangeEvent) => {
    setDomain(event.target.value);
  };
  const domainType = domain as dmsDomainsNamesTy;

  return (
    <Stack gap={3} direction={direction}>
      <ItemSelectInput
        label={label}
        item={""}
        size="full"
        placeholder={placeholder}
        items={DOMAIN_LIST_ITEMS}
        handleChange={handleDomainUpdate}
        value={domain}
        error={domain === "" && submitAttempt}
        errorMessage="Domain is required"
      />

      {domain && domainType === "region" && (
        <RegionSelectInput
          placeholder="Select Region"
          label="Region Name"
          handleChange={handleOnChange}
          value={value?.domain_id}
          error={!value?.domain_id && submitAttempt}
        />
      )}
      {domain && domainType === "district" && (
        <DistrictSelectInput
          placeholder="Select District"
          label="District Name"
          handleChange={handleOnChange}
          value={value?.domain_id}
          error={!value?.domain_id && submitAttempt}
        />
      )}
      {domain && domainType === "division" && (
        <DivisionSelectInput
          placeholder="Select division"
          label="Division Name"
          handleChange={handleOnChange}
          value={value?.domain_id}
          error={!value?.domain_id && submitAttempt}
        />
      )}
      {domain && domainType === "facility" && (
        <FacilitySelectInput
          placeholder="Select facility"
          label="Facility Name"
          handleChange={handleOnChange}
          value={value?.domain_id}
          error={!value?.domain_id && submitAttempt}
        />
      )}
      {domain && domainType === "programme" && (
        <ProgrammeSelectInput
          placeholder="Select programme"
          label="Programme Name"
          handleChange={handleOnChange}
          value={value?.domain_id}
          error={!value?.domain_id && submitAttempt}
        />
      )}
    </Stack>
  );
};
